import { createSelector } from 'reselect'
import { getArrayOfObjectValues } from '../../utils';

export const getProjectActivitiesSelector = createSelector(
  projectActivities => projectActivities.projectActivities,
  (projectActivitiesById) => getArrayOfObjectValues(projectActivitiesById)
);